const ACCORDION_ITEM_CLASSNAME = '.accordion-item';
const ACCORDION_TITLE_CLASSNAME = '.accordion-title';

export const initAccordion = () => {
  const dropdowns = document.querySelectorAll(ACCORDION_ITEM_CLASSNAME);

  if (dropdowns.length) {
    dropdowns.forEach((element) => {
      const accordionTitleEl = element.querySelector(
        ACCORDION_TITLE_CLASSNAME
      ) as HTMLElement;

      accordionTitleEl.addEventListener('click', () =>
        element.classList.toggle('active')
      );
    });
  }
};
